import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46353f52")

_pushScopeId("data-v-46353f52")
const _hoisted_1 = { class: "p-mb-2" }
const _hoisted_2 = { class: "p-grid box" }
const _hoisted_3 = { class: "card card-status-title p-mb-2 p-ml-2" }
const _hoisted_4 = { class: "card card-status-description p-ml-2" }
const _hoisted_5 = { class: "p-col-12 whitebox" }
const _hoisted_6 = { class: "card card-info card-info-title p-mb-1 p-ml-2" }
const _hoisted_7 = { class: "card card-info card-info-description p-mb-1 p-ml-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("a", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView(_ctx.detailView, _ctx.id)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: _ctx.getCssClass(_ctx.cardStatus)
        }, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.cardStatusTitle), 1),
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.cardStatusDescription), 1)
        ], 2),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.cardInfoTitle), 1),
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.cardInfoDescription), 1)
        ])
      ])
    ])
  ]))
})